// This file is auto-generated by Kubb. Do not edit manually.
/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const errorSchema = z.object({
  message: z.string(),
});
